import { render } from "./PreguntasFrecuentesSection.vue?vue&type=template&id=3136b43a&scoped=true"
import script from "./PreguntasFrecuentesSection.vue?vue&type=script&lang=js"
export * from "./PreguntasFrecuentesSection.vue?vue&type=script&lang=js"

import "./PreguntasFrecuentesSection.vue?vue&type=style&index=0&id=3136b43a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3136b43a"]])

export default __exports__